// extracted by mini-css-extract-plugin
export default {"socialMediaIcon":"SocialMedia_socialMediaIcon__kHx7","socialMediaLinkContainer":"SocialMedia_socialMediaLinkContainer_L3jcp"};